export default __webpack_public_path__ + "static/18-48081ee73dcc41c47de586769091b812.webp";